/* eslint-disable angular/factory-name */

angular.
module("digiexam.node").
factory("Node", function DxNodeFactory(
	$http,
	Role,
	Invite,
	NodeTypeEnum,
	QualityStatusEnum,
	DX_NODE_IMAGES,
	DX_DEPRECATION_SETTING
) {
	"use strict";

	function Node(data) {
		var dirty = false;

		angular.extend(this, {
			// Helper properties
			isRolesLoaded: false,
			isUsersLoaded: false,
			isInvitesLoaded: false,

			// Node properties
			id: 0,
			title: "",
			abbr: "",
			about: "",
			city: "",
			state: "",
			country: "",
			type: NodeTypeEnum.NOTSPECIFIED,
			parentId: 0,
			roles: [],
			users: [],
			invites: [],
			profileImage: "",
			coverImage: "",
			freemium: false,
			archived: false,
			qualityStatus: QualityStatusEnum.NOTVERIFIED,
			salesCRMId: "",
			examAdminEmails: [],
			schoolUnitId: "",
			clientWhitelist: [],
			deprecationSetting: DX_DEPRECATION_SETTING.UNMODIFIED,
			disabledStudentCodes: false,
			remoteProctoringSetting: 0,

			// Public functions

			isDirty: function isDirty() {
				return dirty;
			},
			setDirty: function setDirty(state) {
				dirty = state;
				return dirty;
			},
			loadRoles: function loadRoles() {
				var self = this;
				return $http.get("/node/role/list/" + this.id).then(function success(response) {
					var roles = [];

					for (var i = 0; i < response.data.roles.length; i++) {
						var r = response.data.roles[i];
						roles.push(new Role(r));
					}
					self.roles = roles;
					self.isRolesLoaded = true;
					return response.data;
				});
			},
			loadInvites: function loadInvites() {
				var self = this;
				return $http.get("/invite/list/" + this.id).then(function success(response) {
					var invites = [];

					for (var i = 0; i < response.data.length; i++) {
						invites.push(new Invite(response.data[i]));
					}
					self.invites = invites;
					self.isInvitesLoaded = true;
					return response.data;
				});
			},
			addRole: function addRole(roleParameter) {
				var self = this;
				roleParameter.organizationId = this.id;
				return $http.post("/node/role/save/", roleParameter).then(function success(response) {
					var role = new Role(response.data);
					self.roles.push(role);
					return role;
				});
			},
			removeRole: function removeRole(role) {
				var self = this;
				return $http.post("/node/role/remove/", role).then(function success(response) {
					for (var i = 0; i < self.roles.length; i++) {
						if (self.roles[i].id === role.id) {
							self.roles.splice(i, 1);
							break;
						}
					}
					return response.data;
				});
			},
			inviteUser: function inviteUser(invite) {
				var self = this;
				return $http.post("/invite/add/", {emails: invite.emails, roleId: invite.roleId}).then(function success(response) {
					var newInvites = response.data.map(function createInvite(inviteData) {
						return new Invite(inviteData);
					});
					[].push.apply(self.invites, newInvites);
					self.isInvitesLoaded = true;
					return response.data;
				});
			},
			removeInvite: function removeInvite(invite) {
				var self = this;
				return $http.get("/invite/remove/" + invite.id).then(function success(response) {
					if (!response.data.faults) {
						for (var i = 0; i < self.invites.length; i++) {
							var inv = self.invites[i];
							if (inv.id === invite.id) {
								self.invites.splice(i, 1);
								break;
							}
						}
					}
					return response.data;
				});
			},

			save: function save() {
				var self = this;
				return $http.post("/node/save/", this).then(function success(response) {
					if (response.data.faults) {
						angular.extend(self, response.data);
					}
					return response.data;
				});
			},

			// Helper functions

			getProfileImage: function getProfileImage() {
				if (typeof this.profileImageUrl === "string" && this.profileImageUrl.length > 0) {
					return this.profileImageUrl;
				}

				return DX_NODE_IMAGES.PROFILE;
			},

			getCoverImage: function getCoverImage() {
				if (typeof this.coverImageUrl === "string" && this.coverImageUrl.length > 0) {
					return this.coverImageUrl;
				}

				return DX_NODE_IMAGES.COVER;
			},
		});

		if (data) {
			data.roles = data.roles ? data.roles : []; // ANNÖYING
			data.users = data.users ? data.users : []; // ANNÖYING
			data.invites = data.invites ? data.invites : []; // ANNÖYING
			angular.extend(this, data);
		}

		this.isRolesLoaded = this.roles.length > 0;
		this.isUsersLoaded = this.users.length > 0;
		this.isInvitesLoaded = this.invites.length > 0;

		if (!this.examAdminEmails) {
			this.examAdminEmails = [];
		}

		if (!this.clientWhitelist) {
			this.clientWhitelist = [];
		}
	}

	return Node;
});
